import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  clearFilterByKey,
  clearFilterByKeyAndSelectionIndex,
} from "src/store/slice/ProductListingFilterApplied";
import Helper from "../../support/Helper";
import { isString } from "underscore";
import System from "src/helper/system";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
let c = System.getParams();

const CommonFilterSelection = (props) => {
  const { slug, list } = props;
  const dispatch = useDispatch();
  const filter = useSelector(
    (state) => state.entities.ProductListingFilterApplied
  );

  const listMaker = (v, i) => {
    return (
      <React.Fragment key={i}>
        {v.value !== undefined && isString(v.value) && (
          <span className="button-white button-small">
            <span tabIndex={-1} className="filter-item">
              {v.value !== undefined && isString(v.value) && <> {v.value} </>}
            </span>
            <a
              onClick={() => {
                dispatch(
                  clearFilterByKeyAndSelectionIndex({
                    key: slug,
                    selectionIndex: i,
                  })
                );
              }}
            >
              <i className="fa fa-times" />
              <span className="sr-only">Remove Filter</span>
            </a>
          </span>
        )}
      </React.Fragment>
    );
  };

  const getFilterTitle = (title) => {
    let filterText = "";
    switch (title.toLowerCase()) {
      case "categories":
        filterText = "Category";
        break;
      case "family name":
        filterText = "Product Family";
        break;
      case "manufacturer name":
        filterText = "Manufacturer";
        break;
      default:
        filterText = title;
        break;
    }
    return filterText;
  };
  return (
    <>
      {filter[slug] !== undefined && (
        <div className="filter-group">
          <div className="filter-group-title">
            <span tabIndex={-1} className="filter-name noSelect">
              {filter[slug].main_label !== undefined
                ? getFilterTitle(filter[slug].main_label)
                : ""}
            </span>
            <button
              className="remove-filter-group"
              name="categoryId"
              data-di-id="di-id-a9fb693c-94d7a22"
              onClick={() => {
                dispatch(
                  clearFilterByKey({
                    key: slug,
                  })
                );
              }}
            >
              <i className="fa fa-times" />
              <span className="sr-only">Remove Filter</span>
            </button>
          </div>
          <div className="group-filters">
            <div className="group-filter-item">
              <div className="group-filter-item">
                {filter[slug].selection !== undefined &&
                  filter[slug].selection.length > 0 &&
                  filter[slug].selection.map((v, i) => (
                    <React.Fragment key={Helper.UUID()}>
                      {listMaker(v, i)}
                    </React.Fragment>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CommonFilterSelection;
